import { FC } from "react";
import { createStyles, makeStyles, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.error.dark}`,
    },
    title: {
      fontSize: "1rem",
    },
    description: {
      fontSize: "0.875rem",
    },
  }),
);

interface ErrorMessageProps {
  title: string;
  description: string;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ title, description }) => {
  const classes = useStyles();
  return (
    <Alert icon={false} severity="error" className={classes.root}>
      <Typography variant="h6" className={classes.title} gutterBottom>
        {title}
      </Typography>
      <Typography className={classes.description}>{description}</Typography>
    </Alert>
  );
};

export default ErrorMessage;
